import { Component, OnInit } from '@angular/core';
import { ScreeningUtilityService } from '../screening-utility-service';
import { delay, filter } from 'rxjs';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { main } from '@popperjs/core';
import { AlertService } from 'src/app/_services/alert.service';


export class Question {
  "parentId" : number;
  "id": number;
  "radioCheck": String;
  "description": String;
  "row":number;
}


@Component({
  selector: 'app-test-page',
  templateUrl: './test-page.component.html',
  styleUrls: ['./test-page.component.scss']
})
export class TestPageComponent implements OnInit {

  questionList : any[];
  alpha : any[];
  requestData : any[];
  answerForm : FormGroup;
  myForm : FormGroup;
  showProgressBar : boolean = false;
  progress : number = 0;
  constructor(private screeningService : ScreeningUtilityService,private formBuilder : FormBuilder,private alertService : AlertService) { }

  async ngOnInit() {

    // this.answerForm = this.formBuilder.group({
    //   id :[''],
    //   nshRadio : [''],
    //   description : [''],
    // })

    this.answerForm = this.formBuilder.group({
      nshRadio: this.formBuilder.array([
          this.formBuilder.control('')
      ])
  });

  this.myForm = this.formBuilder.group({
    emailList: this.formBuilder.array([
        this.formBuilder.control('')
    ])
});

    this.requestData = [];
    this.screeningService.getMerchantQuestionList("Merchant").subscribe((res:any)=>{
      console.log(res);
      this.questionList = res;
      this.questionList.map((_:any)=>{
         _.isTextField = false;
      })
      console.log(this.questionList);
      console.log(this.requestData);
      this.alpha = ['a','b','c','d','e','f','g','h'];
    })

  }

  yesCheckBox(event:any,id:any,mainId:any,parentId:any){
    
    const radioElement = document.querySelector('input[name="nshRadio' + id + '"]:checked') as HTMLInputElement;
    const  relavancy = radioElement ? radioElement.value : null;
    console.log(relavancy);
    const isChecked = (<HTMLInputElement>event.target).checked;
    console.log(isChecked)
    console.log(id);
    console.log(mainId);
    console.log(parentId);
    if(isChecked == true){
      this.questionList[id].isTextField = true;
    }else{
      this.questionList[id].isTextField = false;
    }
    console.log(this.questionList);
    const newRow = { id: mainId,parentId:parentId,radioCheck:relavancy,description:""};
    this.requestData = [newRow, ...this.requestData];
  }

  noCheckBox(event:any,id:any,mainId:any,parentId:any){
    const isChecked = (<HTMLInputElement>event.target).checked;
    console.log(isChecked)
    console.log(id);
    console.log(mainId);
    console.log(parentId);
    this.questionList[id].isTextField = false;
  }

  yesSubCheckBox(event:any,id:any,subId:any,subParentId:any){
    const radioElement = document.querySelector('input[name="nshRadio' + id + '"]:checked') as HTMLInputElement;
    const  relavancy = radioElement ? radioElement.value : null;
    console.log(relavancy);
    const isChecked = (<HTMLInputElement>event.target).checked;
    console.log(isChecked)
    console.log(id);
    console.log(subId);
    console.log(subParentId);
    if(isChecked == true){
      this.questionList[id].isTextField = true;
    }else{
      this.questionList[id].isTextField = false;
    }
    console.log(this.questionList);
  }

  noSubCheckBox(event:any,id:any,subId:any,subParentId : any){
    const isChecked = (<HTMLInputElement>event.target).checked;
    console.log(isChecked)
    console.log(id);
    console.log(subId);
    console.log(subParentId);
    console.log(this.questionList);
    this.questionList[id].isTextField = false;
  }

  async submit(data:any){
    console.log(data);
    this.showProgressBar = true;
    // this.progress = 0.5;
    for(let i:number=0;i<=100;i++){
      // this.delay(i);
    }
    console.log("done");
  }

  delay(id : any){
    setTimeout(() => {
      console.log("delay")
      this.progress=id;
  }, 3000);
  }

  get emailList() {
    return this.myForm.get('emailList') as FormArray;
    }
    
  addEmail() {
    this.emailList.push(this.formBuilder.control(''));
  }
  
  removeEmail(index: number) {
    this.emailList.removeAt(index);
  }

  questionYesClick(event:any,questionId:any,row:any){
    let count = 0;
    const radioElement = document.querySelector('input[name="nshRadio' + event + '"]:checked') as HTMLInputElement;
    const  relavancy = radioElement ? radioElement.value : null;
    console.log(relavancy);
    console.log(event);
    console.log(questionId)
    console.log(this.requestData.length);
    if(this.requestData.length != 0){
      console.log("Inside If");
      for(let i:number=0;i<this.requestData.length;i++){
        if(this.requestData[i].id == questionId){
          this.requestData[i].radioCheck = relavancy;
          this.questionList[row].isTextField = true;
          count = 1;
        }
      }

      if(count == 0){
        console.log("Inside Count 0");
        const newRow = { id:questionId,radioCheck:relavancy,parentId:0,row:row,description:null};
        this.requestData = [newRow, ...this.requestData];
        this.questionList[row].isTextField = true;
        }
    }else{
      console.log("Inside Else");
      const newRow = { id:questionId,radioCheck:relavancy,parentId:0,row:row,description:null};
      this.requestData = [newRow, ...this.requestData];
      this.questionList[row].isTextField = true;
    }
    console.log(this.requestData);
  }

  questionNoClick(event:any,questionId:any,row:any){
    let count = 0;
    const radioElement = document.querySelector('input[name="nshRadio' + event + '"]:checked') as HTMLInputElement;
    const  relavancy = radioElement ? radioElement.value : null;
    console.log(relavancy);
    console.log(event);
    console.log(questionId)
    console.log(this.requestData.length);
    if(this.requestData.length != 0){
      console.log("Inside If");
      for(let i:number=0;i<this.requestData.length;i++){
        if(this.requestData[i].id == questionId){
          this.requestData[i].radioCheck = relavancy;
          this.questionList[row].isTextField = false;
          count = 1;
        }
      }

      if(count == 0){
      console.log("Inside Count 0");
      const newRow = { id:questionId,radioCheck:relavancy,parentId:0,row:row,description:null};
      this.requestData = [newRow, ...this.requestData];
      this.questionList[row].isTextField = false;
      }
    }else{
      console.log("Inside Else");
      const newRow = { id:questionId,radioCheck:relavancy,parentId:0,row:row,description:null};
      this.requestData = [newRow, ...this.requestData];
      this.questionList[row].isTextField = false;
    }
    console.log(this.requestData);
  }

  subQuestionYesClick(event:any,questionId:any,parentId:any,row:any){
    let count = 0;
    const radioElement = document.querySelector('input[name="nshRadio' + event + '"]:checked') as HTMLInputElement;
    const  relavancy = radioElement ? radioElement.value : null;
    console.log(relavancy);
    console.log(event);
    console.log(questionId)
    console.log(this.requestData.length);
    if(this.requestData.length != 0){
      console.log("Inside If");
      for(let i:number=0;i<this.requestData.length;i++){
        if(this.requestData[i].id == questionId){
          this.requestData[i].radioCheck = relavancy;
          this.questionList[row].isTextField = true;
          count = 1;
        }
      }

      if(count == 0){
        console.log("Inside Count 0");
        const newRow = { id:questionId,radioCheck:relavancy,parentId:parentId,row:row,description:null};
        this.requestData = [newRow, ...this.requestData];
        this.questionList[row].isTextField = true;
        }
    }else{
      console.log("Inside Else");
      const newRow = { id:questionId,radioCheck:relavancy,parentId:parentId,row:row,description:null};
      this.requestData = [newRow, ...this.requestData];
      this.questionList[row].isTextField = true;
    }
    console.log(this.requestData);
  }

  subQuestionNoClick(event:any,questionId:any,parentId:any,row:any){
    let count = 0;
    let check = 0;
    const radioElement = document.querySelector('input[name="nshRadio' + event + '"]:checked') as HTMLInputElement;
    const  relavancy = radioElement ? radioElement.value : null;
    console.log(relavancy);
    console.log(event);
    console.log(questionId)
    console.log(this.requestData.length);
    if(this.requestData.length != 0){
      console.log("Inside If");
      for(let i:number=0;i<this.requestData.length;i++){
        if(this.requestData[i].id == questionId){
          this.requestData[i].radioCheck = relavancy;
          for(let i:number=0;i<this.requestData.length;i++){
            console.log(this.requestData[i]);
            console.log(parentId);
            if(this.requestData[i].parentId == parentId && this.requestData[i].radioCheck == "yes"){
              console.log("disabled")
              check = 1;
            }
          }
          if(check == 0){
            this.questionList[row].isTextField = false;
          }
          count = 1;
        }
      }

      if(count == 0){
      let check1 = 0;
      console.log("Inside Count 0");
      const newRow = { id:questionId,radioCheck:relavancy,parentId:parentId,row:row,description:null};
      this.requestData = [newRow, ...this.requestData];
      for(let i:number=0;i<this.requestData.length;i++){
        console.log(this.requestData[i]);
        console.log(parentId);
        if(this.requestData[i].parentId == parentId && this.requestData[i].radioCheck == "yes"){
          console.log("disabled")
          check = 1;
        }
      }
      if(check1 == 1){
        this.questionList[row].isTextField = false;
      }
      
      }
    }else{
      console.log("Inside Else");
      const newRow = { id:questionId,radioCheck:relavancy,parentId:parentId,row:row,description:null};
      this.requestData = [newRow, ...this.requestData];
      this.questionList[row].isTextField = false;
    }
    console.log(this.requestData);
  }

  submitFinal(){
    let finalChecking : boolean = false;
    let count :number = 0
    for(let i:number=0;i<this.questionList.length;i++){
      if(this.questionList[i].subQuestion.length == 0 ){
        count = count + 1;
        
      }
      else if(this.questionList[i].subQuestion.length != 0 ){
        for(let j:number=0;j<this.questionList[i].subQuestion.length; j++){
          count = count + 1;
        }
      }
    }
    console.log(count)
    console.log(this.requestData.length)
    if(this.requestData.length != count){
      this.alertService.toastWarringMessageAlertWithMessage("Please fill all the questions");
      return;
    }else{
      for(let i:number=0;i<this.requestData.length;i++){
        if(this.requestData[i].radioCheck == "yes"){
          var fieldElement = document.querySelector('[name="description'+this.requestData[i].row+'"]') as HTMLInputElement;
          console.log(fieldElement)
          if(fieldElement != null){
            this.requestData[i].description = fieldElement.value;
          }else if(fieldElement == null){
            this.requestData[i].description = "";
          }
          
        }
      }
      
      console.log("After Description Set");
      console.log(this.requestData)

      for(let i:number=0;i<this.requestData.length;i++){
        if(this.requestData[i].radioCheck == "yes" && this.requestData[i].description == ''){
          console.log(this.requestData[i])
          finalChecking = true;
          this.alertService.toastWarringMessageAlertWithMessage("Please give the description where you have selected YES")
        }
          for(let i:number=0;i<this.requestData.length;i++){
            if(this.requestData[i].radioCheck == "yes" && this.requestData[i].description == '' && this.requestData[i].parentId != 0){
              console.log("Show Bar")
              console.log(this.requestData[i]);
              this.questionList[this.requestData[i].row].error = true;
              this.questionList[this.requestData[i].row].isTextField = true;
            }
            if(this.requestData[i].radioCheck == "yes" && this.requestData[i].description != '' && this.requestData[i].parentId != 0){
              this.questionList[this.requestData[i].row].error = false;
            }
          }

          for(let i:number=0;i<this.requestData.length;i++){
            if(this.requestData[i].radioCheck == "yes" && this.requestData[i].description == '' && this.requestData[i].parentId == 0){
              this.questionList[this.requestData[i].row].error = true;
              this.questionList[this.requestData[i].row].isTextField = true;
            }
            if(this.requestData[i].radioCheck == "yes" && this.requestData[i].description != '' && this.requestData[i].parentId == 0){
              this.questionList[this.requestData[i].row].error = false;
            }
          }
        
      }
    }
    if(!finalChecking){
      console.log("Final Request Data : ",this.requestData)
      this.alertService.successAlert("Questionnaire saved successfully");
    }
  }
  
}
